import { render, staticRenderFns } from "./StoryPhotoEditor.vue?vue&type=template&id=38d53697&scoped=true"
import script from "./StoryPhotoEditor.vue?vue&type=script&lang=js"
export * from "./StoryPhotoEditor.vue?vue&type=script&lang=js"
import style0 from "./StoryPhotoEditor.vue?vue&type=style&index=0&id=38d53697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d53697",
  null
  
)

export default component.exports